<template>
  <div class="kb-review">
    <div class="kb-review-header">
      <h2>上传审核</h2>
      <div class="kb-review-filters">
        <Select v-model="filterStatus" style="width:140px;" placeholder="审核状态">
          <Option value="">全部</Option>
          <Option value="pending">待审核</Option>
          <Option value="approved">已通过</Option>
          <Option value="rejected">已驳回</Option>
        </Select>
        <Input v-model="filterKeyword" search placeholder="搜索文件名" style="width:220px;" clearable />
      </div>
    </div>
    <Table :columns="columns" :data="filteredList" size="default" stripe>
      <template slot-scope="{ row }" slot="status">
        <Tag :color="statusColor(row.status)">{{ statusText(row.status) }}</Tag>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button
          v-if="row.status === 'pending'"
          type="primary"
          size="small"
          @click="approve(row)"
        >通过</Button>
        <Button
          v-if="row.status === 'pending'"
          type="error"
          size="small"
          ghost
          style="margin-left:6px;"
          @click="reject(row)"
        >驳回</Button>
        <span v-else class="kb-reviewed-hint">已处理</span>
      </template>
    </Table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterStatus: '',
      filterKeyword: '',
      columns: [
        {title: '文件名', key: 'name', minWidth: 200},
        {title: '所属目录', key: 'dir', width: 140},
        {title: '上传人', key: 'uploader', width: 100},
        {title: '上传时间', key: 'time', width: 160},
        {title: '状态', slot: 'status', width: 100},
        {title: '操作', slot: 'action', width: 160},
      ],
      list: [
        {id: 1, name: '智慧工地实施方案.docx', dir: '项目案例', uploader: '李四', time: '2026-05-16 14:20', status: 'pending'},
        {id: 2, name: '供应商评估表.xlsx', dir: '管理制度', uploader: '赵六', time: '2026-05-16 10:05', status: 'pending'},
        {id: 3, name: '2026Q1质量分析报告.pdf', dir: '技术规范', uploader: '张三', time: '2026-05-15 16:30', status: 'approved'},
        {id: 4, name: '临时用电安全须知.pptx', dir: '安全手册', uploader: '王五', time: '2026-05-14 09:12', status: 'rejected'},
        {id: 5, name: 'BIM协同操作手册.md', dir: '技术规范', uploader: '王五', time: '2026-05-13 11:40', status: 'approved'},
      ],
    };
  },
  computed: {
    filteredList() {
      return this.list.filter((row) => {
        if (this.filterStatus && row.status !== this.filterStatus) return false;
        if (this.filterKeyword && !row.name.includes(this.filterKeyword)) return false;
        return true;
      });
    },
  },
  methods: {
    statusText(s) {
      return {pending: '待审核', approved: '已通过', rejected: '已驳回'}[s] || s;
    },
    statusColor(s) {
      return {pending: 'warning', approved: 'success', rejected: 'error'}[s] || 'default';
    },
    approve(row) {
      row.status = 'approved';
      this.$Message.success(`已通过：${row.name}`);
    },
    reject(row) {
      row.status = 'rejected';
      this.$Message.warning(`已驳回：${row.name}`);
    },
  },
};
</script>

<style lang="less" scoped>
.kb-review {
  height: 100%;
  overflow: auto;
  padding: 24px 32px;
  background: var(--bg2);
}

.kb-review-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;

  h2 {
    margin: 0;
    font-size: 20px;
  }
}

.kb-review-filters {
  display: flex;
  gap: 10px;
}

.kb-reviewed-hint {
  font-size: 12px;
  color: var(--subtext3);
}
</style>
